import React from 'react';
import { cn } from '../../../lib/utils';

export interface TagProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export function Tag({ children, onClick, className = '' }: TagProps) {
  const getTagClasses = () => {
    return cn(
      'inline-flex items-center justify-center cursor-pointer max-w-full min-w-0',
      'px-3 py-1 h-8 font-sora font-normal text-[14px] leading-[17.6px] text-black max-w-[200px]',
      'rounded-lg bg-secondary-50',
      className,
    );
  };

  return (
    <div className={getTagClasses()} role={onClick ? 'button' : undefined}>
      <span className="truncate max-w-full block">{children}</span>
    </div>
  );
}
